export enum WorkStatus {
  Unknown = 'Unknown',
  Enqueued = 'Enqueued',
  Processing = 'Processing',
  Scheduled = 'Scheduled',
  Succeeded = 'Succeeded',
  Failed = 'Failed',
  Deleted = 'Deleted'
}

// Maps each BackgroundOperationType name to the shape of its extraData.
// Add a new entry here whenever a command implements IBackgroundWorkCommandWithExtraData.
export interface BackgroundOperationExtraData {
  GenerateServiceRequestMatches: { serviceRequestId: string };
}

export type BackgroundOperationType = keyof BackgroundOperationExtraData | (string & {});

export interface InProgressJob<T extends BackgroundOperationType = BackgroundOperationType> {
  jobId: string;
  extraData: T extends keyof BackgroundOperationExtraData ? BackgroundOperationExtraData[T] | null : Record<string, unknown> | null;
}
